import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export function creditColor(amount) {
  return amount >= 0 ? "text-emerald-400" : "text-[#FF6069]";
}

export function creditLabel(amount) {
  return `${amount >= 0 ? "+" : ""}${amount}`;
}

export function fmtDate(s, withTime = false) {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleDateString("en-US", {
      year: "numeric", month: "short", day: "numeric",
      ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}),
    });
  } catch {
    return s;
  }
}

export const txnTypeLabel = {
  "Bottle Activation": "Bottle Activated",
  "Certificate Generated": "Certificate Generated",
  "Admin Credit Added": "Admin Credit Added",
  "Admin Credit Removed": "Admin Credit Removed",
  "Voided Certificate Credit Restored": "Credit Restored",
  "Correction": "Correction",
};

export function useCredits() {
  const [balance, setBalance] = useState(null);
  const refresh = async () => {
    try {
      const { data } = await api.get("/credits/balance");
      setBalance(data);
      return data;
    } catch (e) {
      return null;
    }
  };
  return { balance, refresh, setBalance };
}
